// removed by extract-text-webpack-plugin
module.exports = {"ldsFacebook":"styles__ldsFacebook__2IQ6Z","lightLoader":"styles__lightLoader__3g7kB"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Loader/styles.css
// module id = 2151
// module chunks = 0